import ThankYouPromo from 'components/tailgrids-ui/thank-you/thank-you-promo';
import React from 'react';

export default function ThankYouPromoTastic({ data }) {
  return <ThankYouPromo {...data} />;
}
